<div
  class="month-view-base max-w-[672px] rounded-2xl bg-white text-black mx-auto block h-full w-full"
>
  <div class="month-view-wrapper relative flex flex-col h-full">
    <div class="month-view-header text-white text-center pt-10 pb-5">
      <div
        class="month-view-header-container max-w-[500px] mx-auto flex items-center justify-center gap-5"
      >
        @if (!isPreviousDisabled()) {
          <ss-icon
            class="nav-button-icon nav-button-icon-left w-[30px] h-[30px] flex"
            [icon]="'arrow-plain-white-left' | icon"
            iconalt="Previous month"
            (click)="setPrevMonth()"
            (keydown.enter)="$event.preventDefault(); setPrevMonth()"
            id="prevmonth"
          ></ss-icon>
        }
        <h3 class="date mb-0">{{ months[currMonth()] }} {{ currYear() }}</h3>

        @if (!isNextDisabled()) {
          <ss-icon
            class="nav-button-icon nav-button-icon-right w-[30px] h-[30px] flex"
            [icon]="'arrow-plain-white-right' | icon"
            iconalt="Next month"
            (click)="setNextMonth()"
            (keydown.enter)="$event.preventDefault(); setNextMonth()"
            id="nextmonth"
          ></ss-icon>
        }
      </div>
    </div>
    <div
      #monthViewMain
      class="month-view-main h-[calc(100%-100px)] overflow-auto relative"
      (scroll)="onScroll($event)"
    >
      <div
        class="month-view-color-key flex items-center justify-center gap-2.5 px-5 pt-5 pb-5 font-medium text-xs"
      >
        <span class="color-key color-key-available underline"
          >Available Show</span
        >
        <span class="color-key color-key-sold-out line-through"
          >Sold Out Show</span
        >
      </div>
      <div
        class="month-view-calendar mx-auto flex flex-col gap-2.5 px-5 pb-5 relative"
      >
        <!-- Desktop day headers -->
        <div class="calendar-day-headers grid grid-cols-7 gap-px mb-px">
          @for (day of dayHeaders; track day) {
            <div class="day-header text-center text-sm">
              {{ day }}
            </div>
          }
        </div>

        <!-- Calendar container with overlay -->
        <div class="relative grid gap-2.5 min-h-[400px]">
          <!-- Calendar content -->
          @if (calendar() && calendar().length > 0) {
            @for (week of calendar(); track week) {
              <div class="calendar-week grid grid-cols-7 gap-2.5">
                @for (day of week; track day) {
                  <div
                    #calendarDay
                    class="calendar-day h-auto p-2.5 rounded-md bg-white block transition-colors duration-500 ease-in-out bg-ss-lightest-grey relative text-left overflow-auto"
                    [attr.data-testid]="
                      isLoading() ? 'loading-day' : 'loaded-day'
                    "
                    [class]="getDayClasses(day)"
                  >
                    <div
                      class="calendar-day-header flex flex-row items-center gap-2.5"
                    >
                      <p class="calendar-day-date uppercase text-base w-5">
                        {{ day.day }}
                      </p>
                      <p class="calendar-day-name uppercase text-xs">
                        {{ day.dayOfWeek | slice: 0 : 3 | uppercase }}
                      </p>
                    </div>

                    @if (day?.events && day.events.length > 0) {
                      <ul
                        class="events-list relative flex flex-col overflow-auto pl-1.5"
                      >
                        @for (event of day?.events; track event) {
                          @if (event.time && event.eventCode) {
                            <li
                              class="event-item uppercase text-xs leading-normal"
                            >
                              @if (
                                event.eventStatusCode === 'NA' ||
                                event.eventStatusCode === 'PS' ||
                                event.eventStatusCode === 'SO'
                              ) {
                                <span
                                  class="event-item-link line-through past-event"
                                >
                                  {{ event.time }}
                                </span>
                              } @else if (event.eventStatusCode === 'CO') {
                                @if (isMobile()) {
                                  <a
                                    href="tel:+18003771277"
                                    class="event-item-link cursor-pointer limited inline-flex items-center gap-1"
                                    tabindex="0"
                                  >
                                    {{ event.time }}
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 512 512"
                                      class="w-2.5 h-2.5 fill-current flex-shrink-0"
                                    >
                                      <path
                                        d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
                                      />
                                    </svg>
                                  </a>
                                } @else {
                                  <ss-popover
                                    [dismissable]="true"
                                    [appendToBody]="true"
                                    #eventPopover
                                  >
                                    <button
                                      ss-popover-trigger
                                      class="event-item-link cursor-pointer limited inline-flex items-center gap-1"
                                      (click)="eventPopover.toggle()"
                                    >
                                      {{ event.time }}
                                    </button>
                                    <div
                                      ss-popover-content
                                      class="p-1.5 text-[10px] flex items-center gap-1"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        class="w-2.5 h-2.5 fill-current flex-shrink-0"
                                      >
                                        <path
                                          d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
                                        />
                                      </svg>
                                      (800) 377-1277
                                    </div>
                                  </ss-popover>
                                }
                              } @else {
                                <a
                                  class="event-item-link cursor-pointer"
                                  (click)="onEventClick($event, event)"
                                  (keydown.enter)="onEventClick($event, event)"
                                  tabindex="0"
                                >
                                  {{ event.time }}
                                </a>
                              }
                            </li>
                          }
                        }
                      </ul>
                    }
                  </div>
                }
              </div>
            }
          }

          <!-- Loading overlay -->
          @if (isLoading()) {
            <div
              class="absolute inset-0 bg-white bg-opacity-80 md:flex md:flex-col md:justify-center md:items-center md:gap-3 z-10 transition-opacity duration-300 ease-in-out"
            >
              <ss-spinner
                [height]="40"
                [width]="40"
                color="#2b2b2b"
                class="hidden md:block"
              >
              </ss-spinner>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Bottom gradient for mobile scroll indication -->
    @if (showBottomGradient()) {
      <div
        class="rounded-b-xl md:hidden absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent pointer-events-none z-20 transition-opacity duration-300"
      ></div>
    }
  </div>
</div>
